export default {
  LOGIN: '/auth/super-admin/login',
  LOGOUT: '/auth/logout',
  USER: '/users',
  CHANGE_PASSWORD: '/auth/change-password',
  DEVELOPERS: '/users/developers',
  DEVELOPERS_RESET_PASSWORD: '/users/developers/:id/reset-password',
  DEVELOPER_ACTIVE: '/users/developers/:id/change-active',
  APPLICATIONS: '/applications',
  FACE_DB: '/applications/:appId/face-dbs/cluster',
  FACE_DB_PRIVATE: '/applications/:appId/face-dbs/private',
  UPDATE_FACE_DB_PRIVATE:'/applications/:appId/face-dbs/private/:id',
  SSIDS: '/ssids',
  CREATE_CLUSTER_DB: '/cluster-db',
  APIS: '/api-names',
  API_CATEGORY: '/api-categories',
};
